import { CsSecondaryButton } from '@sunrise/components'
import { computed, defineComponent } from 'vue'
import { commonUtils } from '@sunrise/shared'

export default defineComponent({
    name: 'CsLoadMore',
    components: {
        CsSecondaryButton,
    },
    props: {
        max: {
            type: Number,
            required: true,
        },
        current: {
            type: Number,
            required: true,
        },
        isReduced: Boolean,
        isLoading: Boolean,
        isStateVisible: {
            type: Boolean,
            default: true,
        },
        label: {
            type: String,
            default: '...',
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const limitedCurrent = computed(() => {
            if (outOfLowerBounds(props.current)) {
                return 0
            }

            if (outOfUpperBounds(props.current, props.max)) {
                return props.max
            }

            return props.current
        })

        const computedRight = computed(() => {
            if (outOfLowerBounds(props.current)) {
                return 100
            }

            if (outOfUpperBounds(props.current, props.max)) {
                return 0
            }

            return calculateRight(props.current, props.max)
        })

        const maxFormatted = computed(() => commonUtils.thousandSeparator(props.max))

        const isMaxReached = computed(() => props.current >= props.max)

        function onClick() {
            emit('click')
        }

        return {
            onClick,
            computedRight,
            limitedCurrent,
            maxFormatted,
            isMaxReached,
        }
    },
})

function calculateRight(target: number, max: number) {
    return 100 - convertIntoPercent(target, max)
}

function convertIntoPercent(target: number, max: number) {
    return (target / max) * 100
}

function outOfLowerBounds(target: number) {
    return target <= 0
}

function outOfUpperBounds(target: number, max: number) {
    return target > max
}
